import type { FormTourConfig } from './formTour';

const SEND_OBSERVER_LINK_START_PATH = '/jobs';

export const sendObserverLinkTour = {
  taskId: 'send_observer_link',
  storageKey: 'onboarding-send-observer-link-tour-step',
  startPath: SEND_OBSERVER_LINK_START_PATH,
  navStepCount: 1,
  activePathPrefixes: ['/jobs', '/job'],
  completeTaskViaBackend: true,
  overlineLabel: 'Share Public Link for Job Tour',
  steps: [
    {
      title: 'Open Jobs',
      description: 'Go to Jobs in the sidebar to find the job you want to share with a client.',
      targetTestIds: ['@sidebar-jobs'],
    },
    {
      title: 'Open a job',
      description: 'Click a job title in the list to open the job details.',
      targetTestIds: ['@jobs-table', '@job-detail'],
      highlightTargetTestIds: ['@jobs-table'],
      disableBack: true,
    },
    {
      title: 'Open Public Link',
      description: 'Click the Public Link tab to configure what clients can see.',
      targetTestIds: ['@job-external-observer-tab'],
      disableBack: true,
    },
    {
      title: 'Choose what to share',
      description:
        'Click Options to open the menu. On the Fields tab, select which columns to share. On the Statuses tab, select which statuses to include.',
      targetTestIds: [
        '@observer-options-button',
        '@observer-fields-tab',
        '@observer-fields-section',
        '@observer-statuses-tab',
        '@observer-statuses-section',
      ],
      highlightTargetTestIds: ['@observer-options-popover', '@observer-options-button'],
      showPrimaryWhenTargetTestIds: ['@observer-options-popover'],
      closeTargetTestIdsOnNext: ['@observer-options-button'],
      panelPlacement: 'left',
      disableBack: true,
    },
    {
      title: 'Open the observer link',
      description:
        'Click the external link icon to open the shared view in a new tab, then share that URL with your client.',
      targetTestIds: ['@observer-link-open-external'],
      completeWhenTargetClicked: ['@observer-link-open-external'],
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@jobs-table'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@job-detail'],
      autoAdvanceWhenTargetSatisfied: true,
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@observer-link-panel'],
    },
    3: { type: 'next' },
    4: { type: 'complete' },
  },
} as const satisfies FormTourConfig;
